// plugins/passive-events.js

export const PassiveEvents = () => {
    // ✅ 在创建 Vue 应用前添加 passive 事件处理
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        // 重写 addEventListener 以自动添加 passive 选项
        const originalAddEventListener = EventTarget.prototype.addEventListener
        EventTarget.prototype.addEventListener = function (type, listener, options) {
            // 需要设置为 passive 的事件类型
            const passiveEvents = [
                'touchstart', 'touchmove', 'touchend',
                'wheel', 'mousewheel', 'scroll'
            ]
            // 如果是需要 passive 的事件，且没有明确指定 passive
            if (passiveEvents.includes(type.toLowerCase())) {
                let newOptions = options

                if (typeof options === 'boolean') {
                    newOptions = { capture: options, passive: true }
                } else if (typeof options === 'object') {
                    // 如果没有指定 passive，设为 true
                    if (options.passive === undefined) {
                        newOptions = { ...options, passive: true }
                    } else {
                        newOptions = options
                    }
                } else {
                    newOptions = { passive: true }
                }

                return originalAddEventListener.call(this, type, listener, newOptions)
            }

            return originalAddEventListener.call(this, type, listener, options)
        }
    }
}

